import { User } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'

export type ArchivedContactsWarningState =
  | 'none'
  | 'mixed'
  | 'all-archived-admin-fallback'
  | 'all-archived-no-recipient'

export function getArchivedContactsWarningState(
  partyUsers: DeepReadonly<User[]>,
  selectedIds: readonly string[],
): ArchivedContactsWarningState {
  if (!selectedIds?.length) return 'none'
  const selected = new Set(selectedIds)
  const hasArchivedSelected = partyUsers.some(user => user.archived && selected.has(user.user_id))
  if (!hasArchivedSelected) return 'none'

  const hasActiveSelected = partyUsers.some(user => !user.archived && selected.has(user.user_id))
  if (hasActiveSelected) return 'mixed'

  const hasActiveAdmin = partyUsers.some(user => !user.archived && user.role === 'administrator')
  return hasActiveAdmin ? 'all-archived-admin-fallback' : 'all-archived-no-recipient'
}

const ARCHIVED_CONTACTS_WARNING_COPY: Record<ArchivedContactsWarningState, string> = {
  'none': '',
  'mixed': 'Some selected contacts are archived and won\'t receive the confirmation. Active contacts will still receive it.',
  'all-archived-admin-fallback': 'All selected contacts are archived. The confirmation will go to the company\'s active administrators instead. Update the deal\'s contacts.',
  'all-archived-no-recipient': 'All selected contacts are archived, and the company has no active administrator. The confirmation won\'t be sent. Update the deal\'s contacts.',
}

export function archivedContactsWarning(
  partyUsers: DeepReadonly<User[]>,
  selectedIds: readonly string[],
): string {
  return ARCHIVED_CONTACTS_WARNING_COPY[getArchivedContactsWarningState(partyUsers, selectedIds)]
}
